import { baseURL } from "./config";

// Table avatars are drawn at ~45px. Plain /storage URLs come back as a 720px
// WebP; the image proxy can hand over a 96px one instead (about 9x smaller).
// Anything that is not a /storage jpg/png is returned unchanged.
export const thumb = (url, w = 96) => {
  if (!url || typeof url !== "string") return url;
  const m = url.match(/\/storage\/([^/?#]+\.(?:jpe?g|png))(?:[?#].*)?$/i);
  return m ? `${baseURL}img/${m[1]}?w=${w}` : url;
};
